import React, { useRef, useState } from 'react'

import { useTranslation } from 'react-i18next';

import {
  TableCell,
  OutlinedInput,
  TextField,
  InputAdornment,
  Popper,
  Paper,
  ClickAwayListener,
  Checkbox,
  MenuItem
} from '@material-ui/core'

import { withStyles } from '@material-ui/core/styles'

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'


const CustomTableCellInput = withStyles(theme => ({
    head: {
      backgroundColor: "#55758C",
      color: theme.palette.common.white,
    },
    root:{
      padding: '5px 5px 5px 5px',
      borderBottom:'1px solid #0A1F2E',
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

const CustomOutlinedInput = withStyles (theme => ({
    input: {
        padding: '9px 14px',
        height: '17px',
        color:'white',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    root: {
    "& $notchedOutline": {
    },
    "&:hover $notchedOutline": {
      borderColor: '#205982'
    },
    "&$focused $notchedOutline": {
      borderColor: '#205982'
    }
  },
  focused: {},
  notchedOutline: {}
}))(OutlinedInput);

const CustomOutlinedDropdownInput= withStyles (theme => ({
    input: {
        padding: '9px 14px',
        paddingLeft:'5px',
        paddingBottom:'5px',
        height: '17px',
        color:'white',
    },
    root: {
    "& $notchedOutline": {
    },
    "&:hover $notchedOutline": {
      borderColor: '#205982'
    },
    "&$focused $notchedOutline": {
      borderColor: '#205982'
    }
  },
  focused: {},
  notchedOutline: {}
}))(OutlinedInput);

const FilterDatePickerTextField = withStyles(() => ({
  root: {
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '9px 14px',
      height: '17px',
      color: 'white',
      fontSize: 16,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#205982',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#205982',
    },
    '& .MuiInputLabel-outlined': {
      color: 'white',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: 'white',
    },
  },
}))(React.forwardRef((props, ref) => <TextField {...props} inputRef={ref} />));

function NullTextFilterComponent(props) {
    const { t } = useTranslation()
    const [isOpen, setOpen] = useState(false)
    const [filterValue, setValue] = useState("")
    const {onChange, value, id} = props
    const [empty, setEmpty] = useState(false)
    const textFilter = useRef(null)
    const filterLabel = t('placeholder:Filter');

    const onChangeFilter = (e) => {
        console.log(e)
        const event = {target:{name:id,value:{showNull:empty,value:e.currentTarget.value}}}
        setValue(e.currentTarget.value)
        onChange(event)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleClick = e => {
        setOpen(true)
    }

    const emptyFilter = e => {
        const event = {target:{name:id,value:{showNull:!empty,value:filterValue} || ""}}
        setEmpty(!empty)
        empty ?  onChange(event, false) :  onChange(event, true)
    }

    const options = [
        {
            label: t("Empty"),
            isSelected:empty,
            onSelected: emptyFilter,
        }
    ]

    return (
        <>
            <CustomTableCellInput   key={"cell" + id}  style={{fontSize:16}}>
                <div ref={textFilter}>
                    <CustomOutlinedInput
                        labelWidth={0}
                        placeholder={filterLabel}
                        onChange={(e)=> onChangeFilter(e)}
                        style={{width:'100%',fontSize:15}}
                        name={id}
                        endAdornment={
                            <InputAdornment position="end">
                                    <ArrowDropDownIcon style={{color:"white", cursor:"pointer"}} fontSize="small" onClick={handleClick}/>
                            </InputAdornment>
                            }
                    />
                </div>
            </CustomTableCellInput>
            <Popper anchorEl={textFilter.current} open={isOpen} placement="bottom" popperOptions={{onCreate: (data) => data.instance.popper.style.zIndex = 1}}>
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper style={{position:"relative"}}>
                        {options.map((option, index) =>
                            <div key={index} style={{display: 'flex'}}>
                                <Checkbox checked={option.isSelected} style={{float:"left"}} onChange={option.onSelected}/>
                                <MenuItem onClick={option.onSelected} disabled={!option.isSelected}>{option.label}</MenuItem>
                            </div>
                        )}
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    )
}


export {
    CustomTableCellInput,
    CustomOutlinedInput,
    CustomOutlinedDropdownInput,
    FilterDatePickerTextField,
    NullTextFilterComponent,
}